module.exports = __webpack_public_path__ + "static/media/gallerryimg5.948308a2.jpg";